var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0834 22.9583L11.3763 22.2512L10.6692 22.9583L11.3763 23.6654L12.0834 22.9583ZM16.2096 17.4179L11.3763 22.2512L12.7905 23.6654L17.6238 18.8321L16.2096 17.4179ZM11.3763 23.6654L16.2096 28.4988L17.6238 27.0846L12.7905 22.2512L11.3763 23.6654Z",
    fill: "#273B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17491 18.7292C6.24393 17.1167 5.87103 15.242 6.11407 13.396C6.35711 11.5499 7.20249 9.83566 8.5191 8.51905C9.83571 7.20244 11.55 6.35706 13.396 6.11403C15.242 5.87099 17.1167 6.24388 18.7292 7.17487C20.3417 8.10585 21.602 9.5429 22.3145 11.2631C23.0271 12.9834 23.1521 14.8907 22.6702 16.6892C22.1883 18.4877 21.1263 20.0769 19.6491 21.2104C18.1719 22.3439 16.362 22.9583 14.5 22.9583",
    stroke: "#273B4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a0e2fb5cdfc68d3cc9857bd7187c086b.svg";
export { ForwardRef as ReactComponent };